export default {
  errors(currentState, value) {
    const state = currentState;
    state.errors = value;
  },
};
